import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import App from './App.vue'
import router from './router'
import store from './store'
// import 'lib-flexible'
import './assets/lib/flexible'
import './filters/'
import './directives/'
import './globalComponent'
import './utils/analysis'


import promisePolyfill from 'es6-promise'

// 兼容旧版不支持Promise
promisePolyfill.polyfill()

Vue.config.productionTip = false

// lazy-load 图片懒加载
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: require('./assets/image/clone.png'),
  loading: require('./assets/image/clone.png'),
  attempt: 1
})


// 为兼容IOS cube-ui
if (/i(phone|pad|os)/g.test(navigator.userAgent.toLowerCase())) {
  document.body.classList.add('ios')
}

// 断网提示
window.onoffline = () => {
  router.push({name: 'neterror'})
}

// 每次路由切换置顶
window.addEventListener('hashchange', function () {
  window.scrollTo(0, 0)
}, false)

// let ua = window.navigator.userAgent.toLowerCase()
// if (ua.indexOf('micromessenger') !== -1) {
//   // 在微信端
//   Vue.prototype.$userAgentWx = true
// } else {
//   Vue.prototype.$userAgentWx = false
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
